export default __webpack_public_path__ + "static/GT-America-Standard-Light-685cb8cbabaa4d164bb29811810405ba.woff2";